export default __webpack_public_path__ + "static/media/1739196168277Fusion Logo.99a70172.png";